// ============ SERVICE TYPES ============
export const SERVICE_TYPES = [
  { value: 'gurista-guryaha', label: 'Gurista Guryaha' },
  { value: 'gurista-xafiisyada', label: 'Gurista Xafiisyada' },
  { value: 'gurista-ganacsiyada', label: 'Gurista Ganacsiyada' }
];

// ============ PAYMENT TYPES ============
export const PAYMENT_TYPES = [
  { value: 'EVC Plus', label: 'EVC Plus' },
  { value: 'Dahabshiil Bank', label: 'Dahabshiil Bank'},
  { value: 'Salaam Bank', label: 'Salaam Bank' },
  { value: 'Primmer Bank', label: 'Primer Bank' },
  { value: 'IBS Bank', label: 'IBS Bank' }
];

// ============ EXPENSE CATEGORIES ============
export const EXPENSE_CATEGORIES = [
  { value: 'xamaali', label: 'Xamaali' },
  { value: 'darawal-babur', label: 'Darawal Babur' },
  { value: 'packing', label: 'Packing' },
  { value: 'farsamo-yaqan', label: 'Farsamo Yaqan' },
  { value: 'koronto', label: 'Koronto' },
  { value: 'kirada', label: 'Kirada' },
  { value: 'adeegyada', label: 'Adeegyada' },
];

// ============ DEPARTMENTS ============
export const DEPARTMENTS = [
  { value: 'Xamaali', label: 'Xamaali' },
  { value: 'Supervisor', label: 'Supervisor' },
  { value: 'Baabuur', label: 'Baabuur' },
  { value: 'Packing', label: 'Packing' },
  { value: 'Farsamo Yaqaan', label: 'Farsamo Yaqaan' },
];

/** Maalin / Habeen on work shifts (quotation & invoice). */
export const SHIFT_PERIODS = [
  { value: 'day', label: 'Maalin (Day)' },
  { value: 'night', label: 'Habeen (Night)' }
];

/** Company vehicles assigned per shift (baabuur). */
export const SHIFT_VEHICLES = [
  { value: 'dheyno', label: 'Dheyno' },
  { value: 'dameer-hg', label: 'Dameer Hg' },
  { value: 'tuunus', label: 'Tuunus' }
];

// ============ CATEGORY → DEPARTMENT MAPPING ============
// Maps expense categories to employee departments
// Only worker-type categories are mapped (not koronto, kirada, adeegyada)
export const CATEGORY_TO_DEPARTMENT = {
  'xamaali': 'Xamaali',
  'darawal-babur': 'Baabuur',
  'packing': 'Packing',
  'farsamo-yaqan': 'Farsamo Yaqaan',
};

// ============ QUOTATION STATUS ============
export const QUOTATION_STATUS = {
  pending: { label: 'Sugaya', color: 'bg-yellow-100 text-yellow-800' },
  approved: { label: 'La ansixiyay', color: 'bg-green-100 text-green-800' },
  rejected: { label: 'La diiday', color: 'bg-red-100 text-red-800' },
  invoiced: { label: 'La Invoice Gareyay', color: 'bg-blue-100 text-blue-800' }
};

// ============ DROPDOWN OPTIONS FOR GURISTA GURYAHA ============

// Standard furniture options
const STANDARD_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dibadda-Furfur ah', label: 'Dibadda-Furfur ah' },
  { value: 'dibadda-Isgalis ah', label: 'Dibadda-Isgalis  ah' },
  { value: 'dalka-Furfur ah', label: 'Dalka-Furfur ah' },
  { value: 'dalka-Isgalis ah', label: 'Dalka-Isgalis ah' }
];

// Size options
const SIZE_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'weyn 2.meterah', label: 'Weyn 2.meter ah' },
  { value: 'weyn 4.meterah', label: 'Weyn 4.meter ah' },
  { value: 'yar 2.meter ah', label: 'Yar 2.meter ah' },
  { value: 'yar 4.meter ah', label: 'Yar 4.meter ah' },
];

// Hanta Gas options
const HANTA_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'Bir weyn', label: 'Bir Weyn' },
  { value: 'Bir yar', label: 'Bir Yar' },
  { value: 'Caag weyn', label: 'Caag Weyn' },
  { value: 'Caag yar', label: 'Caag Yar' }
];

// Sariir options
const SARIIR_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'caadi', label: 'Caadi ah' },
  { value: 'ilmo', label: 'Ilmo' },
  { value: '1.5', label: '1.5 Nafar' },
  { value: '2-nafar', label: '2 Nafar' }
];

// Cooker options
const COOKER_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'caadi', label: 'Caadi' },
  { value: 'koronto', label: 'Koronto' },
  { value: 'gas', label: 'Gas' },
  { value: 'fuurno', label: 'Fuurno' }
];
// Finijeer options
const finijer_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dheer', label: 'Dheer' },
  { value: 'gaban', label: 'Gaaban' }
];

// Kuraas options
const KURAAS_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dibadda', label: 'Dibadda' },
  { value: 'dalka', label: 'Dalka' },
  { value: 'caag', label: 'Caag' },
  { value: 'bir', label: 'Bir' }
];

// Joodari options
const JOODARI_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'caadi', label: 'Weyn' },
  { value: 'koronto', label: 'Yar' },
  { value: 'gas', label: '1.Nafar' },
  { value: 'fuurno', label: '2.Nafar' }
];

// Muraaxad options
const MURAAXAD_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'weyn', label: 'Weyn' },
  { value: 'yar', label: 'Yar' }
];

// Miis Fadhi options
const MIISFADHIGA_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'weyn-Dhalo ah', label: 'Weyn-Dhalo ah' },
  { value: 'weyn-Alwax ah', label: 'Weyn-alwax ah' },
  { value: 'yar-Dhalo ah', label: 'Yar-Dhalo ah' },
  { value: 'yar-Alwax ah', label: 'Yar-Alwax ah' }
];

// Kataban options
const KATABAN_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dibadda', label: 'Dibadda' },
  { value: 'dalka', label: 'Dalka' },
  { value: 'bir', label: 'Bir' },
  { value: 'caag', label: 'Caag' }
];

// Cagasaar options
const CAGASAAR_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dibadda', label: 'Dibadda' },
  { value: 'qolka', label: 'Qolka' },
  { value: 'musqusha', label: 'Musqusha' }
];

// Kawo options
const KAWO_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'caag', label: 'Caag' },
  { value: 'caag', label: 'Sandal' },
  { value: 'koolo', label: 'Koolo' },
  { value: 'sports', label: 'Sports' }
];

// Dhar options
const DHAR_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'badan', label: 'Badan' },
  { value: 'yar', label: 'Yar' }
];

export const MUKAYF_IC_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'mukayf', label: 'Mukayf' },
  { value: 'ic', label: 'IC' },
  { value: 'caadi', label: 'Caadi' }
];

// Qasale options
const QASALE_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'otomatic', label: 'Otomatic' },
  { value: 'caadi', label: 'Caadi' },
];

// TV options
const TV_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'weyn', label: 'Weyn' },
  { value: 'yar', label: 'Yar' }
];

// TV options
const ROOG_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'weyn', label: 'Weyn' },
  { value: 'yar', label: 'Yar' }
];



// TV options
const KAWOSAARO_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'bir', label: 'Bir' },
  { value: 'caag', label: 'Caag' }
];

// TV options
const DAHMAN_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'birasha 1.nafar', label: 'Birasha 1.nafar' },
  { value: 'birasha 2.nafar', label: 'Birasha 2.nafar' },
  { value: 'caadi musbaar 1.nafar', label: 'Caadi Musbar 1.nafar' },
  { value: 'caadi musbaar 2.nafar', label: 'Caadi Musbar 2.nafar' }
];

// TV options
const BOORSO_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'boorso dharka', label: 'Borso dharka' },
  { value: 'borso dumar', label: 'Borso dumar' },
  { value: 'borso carurta', label: 'Borso caruurta' }
];

// TV options
const DUCARATION_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'ubax', label: 'Ubax' },
  { value: 'darbiga lagu dhajiyo', label: 'Darbiga lagu dhajiyo' }
];

// TV options
const SHOPPING_OPTIONS = [
  { value: '', label: 'Dooro...' },
  { value: 'dibadda', label: 'Dibadda' },
  { value: 'dalka', label: 'Dalka' },
  { value: 'all', label: 'All' }
];


// ============ GURISTA GURYAHA ITEMS WITH OPTIONS ============
export const GURYAHA_ITEMS = [
  { name: 'Fadhi', options: STANDARD_OPTIONS },
  { name: 'Jiif', options: STANDARD_OPTIONS },
  { name: 'Armaajo', options: STANDARD_OPTIONS },
  { name: 'Sariir', options: SARIIR_OPTIONS },
  { name: 'Finijer', options: finijer_OPTIONS },
  { name: 'Qasale', options: QASALE_OPTIONS },
  { name: 'TV', options: TV_OPTIONS },
  { name: 'Hanta Gas', options: HANTA_OPTIONS },
  { name: 'Cooker', options: COOKER_OPTIONS },
  { name: 'Miis Qado', options: STANDARD_OPTIONS },
  { name: 'Kuraas', options: KURAAS_OPTIONS },
  { name: 'Roog', options: ROOG_OPTIONS },
  { name: 'Shumac', options: SIZE_OPTIONS },
  { name: 'Joodari', options: JOODARI_OPTIONS },
  { name: 'Muraxad', options: MURAAXAD_OPTIONS },
  { name: 'Miis Fadhi', options: MIISFADHIGA_OPTIONS },
  { name: 'Katabaan', options: KATABAN_OPTIONS },
  { name: 'Cagasaar', options: CAGASAAR_OPTIONS },
  { name: 'Dahman', options: DAHMAN_OPTIONS },
  { name: 'Boorso', options: BOORSO_OPTIONS },
  { name: 'Decoration', options: DUCARATION_OPTIONS },
  { name: 'Shopping', options: SHOPPING_OPTIONS },
  { name: 'Mukayf', options: MUKAYF_IC_OPTIONS }
];


// ✅ NEW: HOUSE TYPES
export const HOUSE_TYPES = [
  { value: 'guri-caadi', label: 'Guri Caadi' },
  { value: 'dabaq', label: 'Dabaq' }
];

// ✅ NEW: DESTINATION TYPES (Where are you moving to?)
export const DESTINATION_TYPES = [
  { value: 'guri-caadi', label: 'Guri Caadi ah' },
  { value: 'dabaq', label: 'Dabaq / Biyaano' }
];

// ✅ NEW: FLOOR LEVELS (Biyaanada)
export const FLOOR_OPTIONS = [
  { value: '1', label: 'Biyaanada 1aad' },
  { value: '2', label: 'Biyaanada 2aad' },
  { value: '3', label: 'Biyaanada 3aad' },
  { value: '4', label: 'Biyaanada 4aad' },
  { value: '5', label: 'Biyaanada 5aad' },
  { value: '6', label: 'Biyaanada 6aad' },
  { value: '7', label: 'Biyaanada 7aad' },
  { value: '8', label: 'Biyaanada 8aad' },
  { value: '9', label: 'Biyaanada 9aad' },
  { value: '10', label: 'Biyaanada 10aad' },
  { value: '11', label: 'Biyaanada 11aad' },
  { value: '12', label: 'Biyaanada 12aad' },
  { value: '13', label: 'Biyaanada 13aad' },
  { value: '14', label: 'Biyaanada 14aad' },
  { value: '15', label: 'Biyaanada 15aad' },
  { value: '16', label: 'Biyaanada 16aad' },
  { value: '17', label: 'Biyaanada 17aad' },
  { value: '18', label: 'Biyaanada 18aad' },
  { value: '19', label: 'Biyaanada 19aad' },
  { value: '20', label: 'Biyaanada 20aad' }
];

// ✅ NEW: BIYAANO FEATURES (Checkboxes)
export const BIYAANO_FEATURES = [
  { value: 'wiish', label: 'Wiish (Elevator)' },
  { value: 'jaranjar', label: 'Jaranjar (Stairs)' }
];

// ============ GURISTA XAFIISYADA ITEMS ============
export const XAFIISYADA_ITEMS = [
  'Desk',
  'Monitor',
  'Keyboard',
  'Mouse',
  'Chair',
  'Computer',
  'Printer',
  'Projector',
  'Whiteboard',
  'Wardrobe',
  'Armaajo',
  'Clipboard',
  'Files',
  'Folder',
  'Paper',
  'Notebook',
  'Pen',
  'Pencil',
  'Mukayf',
  'Stapler',
  'Tape',
  'Scissors',
  'Calculator',
  'Envelope',
  'Highlighter',
  'Binder Clip',
  'Paper Knife',
  'Stationery',
  'Lanyard',
  'Despine',
  'Kan tishka la rido',
  'Kan waraqda lagu qabto',
  'Holpanii warqada lagu duleliyo',
  'Stamp'
];

// Legacy columns (for backward compatibility)
export const GURYAHA_COLUMNS = [
  { key: 'selection', label: 'Nooca' },
  { key: 'damaged', label: 'Dhaawac' },
  { key: 'quantity', label: 'Tirada' }
];

export const PROJECT_COST_LINE_TEMPLATES = [
  { value: 'babuur-shirkada', label: 'Babuur shirkada' },
  { value: 'farsamo-shirkada', label: 'Farsamo shirkada' },
  { value: 'xamaali-shirkada', label: 'Xamaali shirkada' },
  { value: 'delivery-shirkada', label: 'Delivery shirkada' },
  { value: 'alasow', label: 'Alasow' },
  { value: 'koolo-shirkada', label: 'Koolo shirkada' },
  { value: 'casriye-mamulka', label: 'Casriye mamulka' },
  { value: 'bacwaste-shirkada', label: 'Bacwaste shirkada' },
  { value: 'qado-mamulka', label: 'Qado mamulka' }
];

export const PROJECT_COST_TO_EXPENSE_CATEGORY = {
  'babuur-shirkada': 'darawal-babur',
  'farsamo-shirkada': 'farsamo-yaqan',
  'xamaali-shirkada': 'xamaali',
  'delivery-shirkada': 'adeegyada',
  'alasow': 'xamaali',
  'koolo-shirkada': 'adeegyada',
  'casriye-mamulka': 'adeegyada',
  'bacwaste-shirkada': 'packing',
  'qado-mamulka': 'adeegyada'
};